var map = {
	"./$pac.png": "8001",
	"./0xbtc.png": "08b2",
	"./2give.png": "2ec7",
	"./aave.png": "715c",
	"./abt.png": "09c1",
	"./act.png": "88e8",
	"./actn.png": "775d",
	"./ada.png": "91b2",
	"./add.png": "9de6",
	"./adx.png": "1b32",
	"./ae.png": "4e18",
	"./aeon.png": "b7a9",
	"./aeur.png": "d31e",
	"./agi.png": "6a23",
	"./agrs.png": "8567",
	"./aion.png": "26c5",
	"./algo.png": "e174",
	"./amb.png": "4984",
	"./amp.png": "8f7b",
	"./ampl.png": "bc3e",
	"./ankr.png": "606d",
	"./ant.png": "2b72",
	"./apex.png": "a0e8",
	"./appc.png": "60ed",
	"./ardr.png": "3748",
	"./arg.png": "09c4",
	"./ark.png": "3d44",
	"./arn.png": "66b6",
	"./arnx.png": "83e5",
	"./ary.png": "6b3a",
	"./ast.png": "f89d",
	"./atm.png": "9b7c",
	"./atom.png": "83e0",
	"./audr.png": "8b03",
	"./auto.png": "1f95",
	"./aywa.png": "fbd2",
	"./bab.png": "d9c9",
	"./bal.png": "75ec",
	"./band.png": "4c8a",
	"./bat.png": "0e7c",
	"./bay.png": "7cfd",
	"./bcbc.png": "eb37",
	"./bcc.png": "e28a",
	"./bcd.png": "5e49",
	"./bch.png": "c755",
	"./bcio.png": "e1ab",
	"./bcn.png": "4e4e",
	"./bco.png": "1784",
	"./bcpt.png": "fe6b",
	"./bdl.png": "031e",
	"./beam.png": "4406",
	"./bela.png": "c25c",
	"./bix.png": "c810",
	"./blcn.png": "ff68",
	"./blk.png": "b18f",
	"./block.png": "9f77",
	"./blz.png": "07b4",
	"./bnb.png": "805e",
	"./bnt.png": "944e",
	"./bnty.png": "bdce",
	"./booty.png": "1c89",
	"./bos.png": "002b",
	"./bpt.png": "a343",
	"./bq.png": "c1da",
	"./brd.png": "54ee",
	"./bsd.png": "9bfd",
	"./bsv.png": "546f",
	"./btc.png": "ea50",
	"./btcd.png": "87f7",
	"./btch.png": "7712",
	"./btcp.png": "8f8d",
	"./btcz.png": "08f2",
	"./btdx.png": "b65e",
	"./btg.png": "f4c4",
	"./btm.png": "6b28",
	"./bts.png": "8f4d",
	"./btt.png": "5027",
	"./btx.png": "aa84",
	"./burst.png": "8d9e",
	"./bze.png": "f205",
	"./call.png": "c0e7",
	"./cc.png": "5c98",
	"./cdn.png": "04bd",
	"./cdt.png": "8cad",
	"./cenz.png": "b374",
	"./chain.png": "1853",
	"./chat.png": "3ca5",
	"./chips.png": "ca2f",
	"./chsb.png": "5579",
	"./cix.png": "fbcc",
	"./clam.png": "8010",
	"./cloak.png": "adbc",
	"./cmm.png": "6a70",
	"./cmt.png": "cf99",
	"./cnd.png": "9930",
	"./cnx.png": "75b7",
	"./cny.png": "a906",
	"./cob.png": "d524",
	"./colx.png": "a6be",
	"./comp.png": "e695",
	"./coqui.png": "2590",
	"./cred.png": "9145",
	"./crpt.png": "5993",
	"./crv.png": "f426",
	"./crw.png": "1a57",
	"./cs.png": "3f46",
	"./ctr.png": "ffc6",
	"./ctxc.png": "e371",
	"./cvc.png": "142d",
	"./d.png": "a8b8",
	"./dai.png": "0360",
	"./dash.png": "ebe9",
	"./dat.png": "0918",
	"./data.png": "e5b3",
	"./dbc.png": "64ab",
	"./dcn.png": "2332",
	"./dcr.png": "ba8a",
	"./deez.png": "9468",
	"./dent.png": "ef7d",
	"./dew.png": "8f23",
	"./dgb.png": "6ea9",
	"./dgd.png": "f004",
	"./dlt.png": "6bb1",
	"./dnt.png": "9d35",
	"./dock.png": "6c72",
	"./doge.png": "3bb5",
	"./dot.png": "5180",
	"./drgn.png": "edc7",
	"./drop.png": "e010",
	"./dta.png": "3b63",
	"./dth.png": "ad6b",
	"./dtr.png": "e648",
	"./ebst.png": "8106",
	"./eca.png": "6f0d",
	"./edg.png": "9422",
	"./edo.png": "168c",
	"./edoge.png": "aabe",
	"./ela.png": "296d",
	"./elec.png": "2095",
	"./elf.png": "0506",
	"./elix.png": "9bc8",
	"./ella.png": "1a9a",
	"./emb.png": "7f77",
	"./emc.png": "20bf",
	"./emc2.png": "c03f",
	"./eng.png": "bccd",
	"./enj.png": "ff18",
	"./entrp.png": "d86a",
	"./eon.png": "71e5",
	"./eop.png": "ac24",
	"./eos.png": "6ecb",
	"./eqli.png": "73aa",
	"./equa.png": "2925",
	"./etc.png": "8294",
	"./eth.png": "c4db",
	"./ethos.png": "4567",
	"./etn.png": "7e4d",
	"./etp.png": "8625",
	"./eur.png": "4922",
	"./evx.png": "25bb",
	"./exmo.png": "e30c",
	"./exp.png": "54e9",
	"./fair.png": "2c59",
	"./fct.png": "93d4",
	"./fil.png": "3487",
	"./fjc.png": "74f7",
	"./fldc.png": "b0f3",
	"./flo.png": "738c",
	"./flux.png": "3c65",
	"./fsn.png": "e2fc",
	"./ftc.png": "4c4c",
	"./fuel.png": "defe",
	"./fun.png": "2ae1",
	"./game.png": "f118",
	"./gas.png": "ca5a",
	"./gbp.png": "476a",
	"./gbx.png": "e972",
	"./gbyte.png": "b84b",
	"./generic.png": "5bff",
	"./gin.png": "5f95",
	"./glxt.png": "aad2",
	"./gmr.png": "8027",
	"./gno.png": "afe1",
	"./gnt.png": "36b9",
	"./gold.png": "faeb",
	"./grc.png": "8da1",
	"./grin.png": "ec55",
	"./grs.png": "4df9",
	"./grt.png": "ceb9",
	"./gsc.png": "8e30",
	"./gto.png": "e0fd",
	"./gup.png": "7e7a",
	"./gusd.png": "91ab",
	"./gvt.png": "46cb",
	"./gxs.png": "e1c3",
	"./gzr.png": "e292",
	"./hight.png": "e21a",
	"./hns.png": "2783",
	"./hodl.png": "075a",
	"./hot.png": "4078",
	"./hpb.png": "9214",
	"./hsr.png": "5268",
	"./ht.png": "be4f",
	"./html.png": "9d52",
	"./huc.png": "a81f",
	"./husd.png": "7c67",
	"./hush.png": "7f5f",
	"./icn.png": "a8e2",
	"./icp.png": "245a",
	"./icx.png": "1222",
	"./ignis.png": "2a08",
	"./ilk.png": "4695",
	"./ink.png": "8d6f",
	"./ins.png": "1190",
	"./ion.png": "c365",
	"./iop.png": "0a90",
	"./iost.png": "aaed",
	"./iotx.png": "d094",
	"./iq.png": "2fe3",
	"./itc.png": "8319",
	"./jnt.png": "80ed",
	"./jpy.png": "03db",
	"./kcs.png": "aa94",
	"./kin.png": "6db9",
	"./klown.png": "c2b3",
	"./kmd.png": "50f9",
	"./knc.png": "a56b",
	"./krb.png": "bca3",
	"./ksm.png": "09e7",
	"./lbc.png": "b635",
	"./lend.png": "2a26",
	"./leo.png": "2e64",
	"./link.png": "2610",
	"./lkk.png": "7430",
	"./loom.png": "cb65",
	"./lpt.png": "fcbe",
	"./lrc.png": "2a2c",
	"./lsk.png": "155a",
	"./ltc.png": "c912",
	"./lun.png": "c09b",
	"./maid.png": "2e3f",
	"./mana.png": "6a85",
	"./matic.png": "1f52",
	"./max.png": "0f0d",
	"./mcap.png": "b909",
	"./mco.png": "d56d",
	"./mda.png": "0f98",
	"./mds.png": "d8f0",
	"./med.png": "0c95",
	"./meetone.png": "24ee",
	"./mft.png": "ad75",
	"./miota.png": "8207c",
	"./mith.png": "df42",
	"./mkr.png": "67e2",
	"./mln.png": "f189",
	"./mnx.png": "1a43",
	"./mnz.png": "d668",
	"./moac.png": "5b99",
	"./mod.png": "027d",
	"./mona.png": "ac4d",
	"./msr.png": "8d5a",
	"./mth.png": "cca2",
	"./mtl.png": "6699",
	"./music.png": "3c1d",
	"./mzc.png": "a74cd",
	"./nano.png": "7379",
	"./nas.png": "5a60",
	"./nav.png": "ed38",
	"./ncash.png": "6cdb",
	"./ndz.png": "f1de",
	"./nebl.png": "1984",
	"./neo.png": "531d",
	"./neos.png": "94ef",
	"./neu.png": "5f53",
	"./nexo.png": "ac05",
	"./ngc.png": "2d7c",
	"./nio.png": "937a",
	"./nkn.png": "c9b1",
	"./nlc2.png": "8794",
	"./nlg.png": "65d1",
	"./nmc.png": "9ddd",
	"./nmr.png": "69cd",
	"./npxs.png": "a0ec",
	"./ntbc.png": "f303",
	"./nuls.png": "521e",
	"./nxs.png": "0cfbe",
	"./nxt.png": "db71",
	"./oax.png": "8c53",
	"./ok.png": "a76f",
	"./omg.png": "60bd",
	"./omni.png": "8dd5",
	"./one.png": "c822",
	"./ong.png": "d308",
	"./ont.png": "01dd",
	"./oot.png": "6f7b",
	"./ost.png": "cbf3",
	"./ox.png": "f4ce",
	"./oxt.png": "78e0",
	"./part.png": "209d",
	"./pasc.png": "7e7a3",
	"./pasl.png": "9f99",
	"./pax.png": "b558",
	"./paxg.png": "a8dd",
	"./pay.png": "4aea",
	"./payx.png": "b147",
	"./pink.png": "f0a7",
	"./pirl.png": "2055",
	"./pivx.png": "1397",
	"./plr.png": "5646",
	"./poa.png": "1610",
	"./poe.png": "6ab9",
	"./polis.png": "b4a0",
	"./poly.png": "14f2",
	"./pot.png": "b337",
	"./powr.png": "5226",
	"./ppc.png": "8381",
	"./ppp.png": "3553",
	"./ppt.png": "ab9d",
	"./pre.png": "e3ce",
	"./prl.png": "5851",
	"./pungo.png": "057d",
	"./pura.png": "b9dd",
	"./qash.png": "5805",
	"./qiwi.png": "485a0",
	"./qlc.png": "03d3",
	"./qrl.png": "e586",
	"./qsp.png": "1b97",
	"./qtum.png": "475d",
	"./r.png": "aaeb",
	"./rads.png": "8907",
	"./rap.png": "1c9f",
	"./rcn.png": "cc59",
	"./rdd.png": "6ba4",
	"./rdn.png": "d723",
	"./ren.png": "ceb4",
	"./rep.png": "91ae",
	"./repv2.png": "676d",
	"./req.png": "7c3d",
	"./rhoc.png": "a917",
	"./ric.png": "806a",
	"./rise.png": "7236",
	"./rlc.png": "9e55",
	"./rpx.png": "2a22",
	"./rub.png": "cda5",
	"./rvn.png": "0d27",
	"./ryo.png": "60da1",
	"./safe.png": "6508",
	"./safemoon.png": "a90f",
	"./sai.png": "273f",
	"./salt.png": "c0c6",
	"./san.png": "d68a",
	"./sand.png": "9c9d",
	"./sbd.png": "2149",
	"./sberbank.png": "436f",
	"./sc.png": "0920",
	"./shift.png": "cb39",
	"./sib.png": "f42e",
	"./sin.png": "5d97",
	"./skl.png": "2c0c",
	"./sky.png": "4621",
	"./slr.png": "4245",
	"./sls.png": "88b4",
	"./smart.png": "3a67",
	"./sngls.png": "cf5a",
	"./snm.png": "bde3",
	"./snt.png": "9d5c",
	"./snx.png": "9d6a",
	"./soc.png": "a865",
	"./sol.png": "dd1e",
	"./spacehbit.png": "cb8c",
	"./spank.png": "a7f4",
	"./sphtx.png": "5f5f",
	"./srn.png": "99af0",
	"./stak.png": "5621",
	"./start.png": "3d06",
	"./steem.png": "c8e7",
	"./storj.png": "f348",
	"./storm.png": "bae0",
	"./stox.png": "f062",
	"./stq.png": "3f74",
	"./strat.png": "d2da",
	"./stx.png": "b62a",
	"./sub.png": "7355",
	"./sumo.png": "b444",
	"./sushi.png": "b561",
	"./sys.png": "4d31",
	"./taas.png": "42a6",
	"./tau.png": "13d8",
	"./tbx.png": "3572",
	"./tel.png": "c743",
	"./ten.png": "88d3",
	"./tern.png": "0430",
	"./tgch.png": "0ed3",
	"./theta.png": "5641",
	"./tix.png": "bd85",
	"./tkn.png": "38f3",
	"./tks.png": "d55b",
	"./tnb.png": "c2ce",
	"./tnc.png": "955d",
	"./tnt.png": "a2ca",
	"./tomo.png": "f92d",
	"./tpay.png": "9310",
	"./trig.png": "77fb",
	"./trtl.png": "97a3",
	"./trx.png": "ba8b",
	"./tusd.png": "d6b5",
	"./tzc.png": "fa5c",
	"./ubq.png": "9d0a",
	"./uma.png": "2bfd",
	"./uni.png": "3b71",
	"./unity.png": "60d3",
	"./usd.png": "cd70",
	"./usdc.png": "f8cd",
	"./usdt.png": "ae26",
	"./utk.png": "a5b9",
	"./veri.png": "5abd",
	"./vet.png": "abba",
	"./via.png": "a66f",
	"./vib.png": "6402",
	"./vibe.png": "6b03",
	"./vivo.png": "1364",
	"./vrc.png": "aace",
	"./vrsc.png": "cfb7",
	"./vtc.png": "d65e",
	"./vtho.png": "fac8",
	"./wabi.png": "77e5",
	"./wan.png": "1842",
	"./waves.png": "7aa3",
	"./wax.png": "0bfc",
	"./wbtc.png": "61b3",
	"./wgr.png": "ecda",
	"./wicc.png": "b467",
	"./wings.png": "5eda",
	"./wpr.png": "c010",
	"./wtc.png": "fb58",
	"./x.png": "3d8d",
	"./xas.png": "50dc",
	"./xbc.png": "3eea",
	"./xbp.png": "76ca",
	"./xby.png": "b7c3",
	"./xcp.png": "4e97",
	"./xdn.png": "e6ca",
	"./xem.png": "826c",
	"./xin.png": "aec8",
	"./xlm.png": "697d",
	"./xmcc.png": "d77e",
	"./xmg.png": "ad39",
	"./xmo.png": "de4d",
	"./xmr.png": "4700",
	"./xmy.png": "7cb0",
	"./xp.png": "65ff",
	"./xpa.png": "c8a0",
	"./xpm.png": "3aa5",
	"./xpr.png": "8960",
	"./xrp.png": "a489",
	"./xsg.png": "8208",
	"./xtz.png": "5e07",
	"./xuc.png": "2fed",
	"./xvc.png": "d4a0",
	"./xvg.png": "4dc6",
	"./xzc.png": "6212",
	"./yfi.png": "4561",
	"./yoyow.png": "a677",
	"./zcl.png": "ad8f",
	"./zec.png": "330c",
	"./zel.png": "194e",
	"./zen.png": "a715",
	"./zest.png": "1d9a",
	"./zil.png": "1bd0",
	"./zilla.png": "2cf0",
	"./zrx.png": "7091"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3aa3";